var _excluded = ["input", "id", "meta", "className", "children", "maskOptions"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { blurDirty, fieldPropTypes, hasInputError, omitLabelProps } from '../helpers';
import { LabeledField } from '../labels';
import { compose, filterInvalidDOMProps, generateInputErrorId } from '../../utils';
import Cleave from 'cleave.js/react';
/**
 *
 * A masked input that can be used in a `redux-forms`-controlled form. Built on top of [cleave.js](https://github.com/nosir/cleave.js).
 * 
 * @name MaskedInput
 * @type Function
 * @param {Object} input - A `redux-forms` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object
 * @param {Object} meta - A `redux-forms` [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) object
 * @param {Object} [maskOptions] - An object of options to pass to the underlying `Cleave` instance. [(supported options)](https://github.com/nosir/cleave.js/blob/master/doc/options.md)
 * @example
 * 
 * function PurchaseForm ({ handleSubmit, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field 
 *          name="quantity"
 *          component={ MaskedInput }
 *          maskOptions={{ numeral: true }}
 *       />
 *       <SubmitButton submitting={submitting}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 */

var propTypes = _objectSpread(_objectSpread({}, fieldPropTypes), {}, {
  maskOptions: PropTypes.object,
  children: PropTypes.node
});

var defaultProps = {
  maskOptions: {}
};

function MaskedInput(props) {
  var _omitLabelProps = omitLabelProps(props),
      _omitLabelProps$input = _omitLabelProps.input,
      name = _omitLabelProps$input.name,
      value = _omitLabelProps$input.value,
      onBlur = _omitLabelProps$input.onBlur,
      onChange = _omitLabelProps$input.onChange,
      id = _omitLabelProps.id,
      meta = _omitLabelProps.meta,
      className = _omitLabelProps.className,
      children = _omitLabelProps.children,
      maskOptions = _omitLabelProps.maskOptions,
      rest = _objectWithoutProperties(_omitLabelProps, _excluded);

  return (
    /*#__PURE__*/
    React.createElement(LabeledField, props,
    /*#__PURE__*/
    React.createElement("div", {
      className: "input-wrapper"
    },
    /*#__PURE__*/
    React.createElement(Cleave, _objectSpread({
      id: id || name,
      name: name,
      value: value,
      onBlur: onBlur,
      onChange: onChange,
      'aria-describedby': hasInputError(meta) ? generateInputErrorId(name) : null,
      options: maskOptions
    }, filterInvalidDOMProps(rest))), children))
  );
}

MaskedInput.defaultProps = defaultProps;
MaskedInput.propTypes = propTypes;
export default compose(blurDirty())(MaskedInput);